import { render, staticRenderFns } from "./DataTableCustomField.vue?vue&type=template&id=0c8d2802"
import script from "./DataTableCustomField.vue?vue&type=script&lang=js"
export * from "./DataTableCustomField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports